var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.guide.template)?_c('viewer-svg',{attrs:{"svg":_vm.cover_svg,"fields":_vm.fields}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }